import Vue from 'vue'
import Router from 'vue-router'
import Layout from './views/Layout.vue'
import store from './store/index'

Vue.use(Router)

// lazy-loaded
function loadView(path) {
	return () => import(/* webpackChunkName: "view-[request]" */ `${path}`)
}

const router = new Router({
	mode: process.env.NODE_ENV === 'development' ? 'hash' : 'history',
	routes: [
		{
			path: '/',
			component: Layout,
			children: [
				{
					path: '/',
					name: 'home',
					component:
						process.env.VUE_APP_HOME_ISPUBLIC === 'true'
							? loadView('./views/Home/index.vue')
							: loadView('./views/Home/building.vue'),
				},
				{
					path: 'login',
					name: 'login',
					component: loadView('./views/Login/index.vue'),
				},
				{
					path: 'post',
					name: 'post',
					component: loadView('./views/Upload/index.vue'),
				},
				{
					path: 'watch',
					name: 'watch',
					component: loadView('./views/Watch/index.vue'),
				},
				{
					path: 'building',
					name: 'building',
					component: loadView('./views/Building.vue'),
				},
				{
					path: '404',
					name: 'NotFound',
					component: loadView('./views/404/index.vue'),
				},
				{
					path: '*',
					redirect: '/404',
				},
			],
		},
	],
})

router.beforeEach(async (to, from, next) => {
  // 获取基础配置
  await store.dispatch('Config/getBaseInfo')

	if (to.name == 'home' && from.name == null) {
		// 在首页刷新
		store.dispatch('Home/clearFilter')
		store.dispatch('Home/clearRandomList')
	}
	if (!store.state.Config.UPLOAD_OPEN) {
		if (to.name == 'post' || to.name == 'login') {
			next('/building')
		} else {
			next()
		}
	} else {
		if (to.name == 'post') {
			store
				.dispatch('User/getUserInfo')
				.then(v => {
					if (v.retcode == 2000) {
						next()
					}
				})
				.catch(e => {
					console.log(e)
				})
		} else {
			next()
		}
	}
})

export default router
